import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = '/cosindex/api/v1';
export const GET_PAGES_FOR_FORM_FIELD_NAME = 'pagesForForm';
export const GET_PAGES_FOR_FORM = registerQuery({
  fieldName: GET_PAGES_FOR_FORM_FIELD_NAME,
  args: ['id'],
  fetcher({
    id
  }) {
    return http.get(`${BASE_URL}/connections/parents`, {
      query: {
        id,
        parentType: 'CONTENT',
        levels: 0,
        fields: 'BASIC'
      }
    }).then(formToPages => formToPages[id] ? formToPages[id] : []);
  }
});
export function useFetchPagesForForm({
  guid,
  skip
}) {
  const {
    data,
    error,
    loading
  } = useQuery(GET_PAGES_FOR_FORM, {
    variables: {
      id: guid
    },
    skip
  });
  return useMemo(() => ({
    data: data && data[GET_PAGES_FOR_FORM_FIELD_NAME],
    error,
    loading
  }), [data, error, loading]);
}